import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

export function dashboardApi(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/pwa`, {
      headers,
      params: {
        v: config.version,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200) {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function consultationTab(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/care`, {
      headers,
      params: {
        v: config.version,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function homeTab(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/home`, {
      headers,
      params: {
        v: config.v2,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message !== 'success') {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }

      return responseBody;
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function fetchUpgradePackages(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/labs-v3/upgrade-packages`, {
      headers,
      params: {
        v: config.version,
      },
    })
    .then((resp) => resp.data)
    .catch((err) => {
      showError(err);
      return null;
    });
}

export function endChat(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/users/chat/close?init=0`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      // throw err;
    });
}

export function updateProfile(body, authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/users/update/profile`, body, { headers })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'profileUpdated') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function popup(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/popups`, {
      headers,
      // params: {
      //   v: config.version,
      // },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200) {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}
